import { RouteConfig } from "vue-router";

export const RCandidateTasksBrowse: RouteConfig = {
  path: "",
  name: "CandidateTasksBrowse",
  component: () =>
    import(
      /* webpackChunkName: "tasks-browse" */
      "./VCandidateTasksBrowse.vue"
    ),
  meta: {
    title: "Tasks",
  },
};
